<template>
  <base-container class="time-picker-page">
    <cube-basic-picker></cube-basic-picker>

    <view class="picker-divider-wrapper">
      <cube-divider></cube-divider>
    </view>

    <cube-config-day-picker></cube-config-day-picker>

    <view class="picker-divider-wrapper">
      <cube-divider></cube-divider>
    </view>

    <cube-config-format-picker></cube-config-format-picker>

    <view class="picker-divider-wrapper">
      <cube-divider></cube-divider>
    </view>

    <cube-config-minute-picker></cube-config-minute-picker>

    <view class="picker-divider-wrapper">
      <cube-divider></cube-divider>
    </view>

    <cube-config-delay-picker></cube-config-delay-picker>

    <view class="picker-divider-wrapper">
      <cube-divider></cube-divider>
    </view>

    <cube-set-time-picker></cube-set-time-picker>
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus">
.picker-divider-wrapper
  margin 10px 0
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index",
      "cube-basic-picker": "./basic-picker",
      "cube-config-day-picker": "./config-day-picker",
      "cube-config-format-picker": "./config-format-picker",
      "cube-config-minute-picker": "./config-minute-picker",
      "cube-config-delay-picker": "./config-delay-picker",
      "cube-set-time-picker": "./set-time-picker"
    }
  }
</script>
